import styled from 'styled-components';

export const Container = styled('div')`
  color: ${(props) => (!props.withSettings ? props.theme.colors.disabledMeatballItem : props.theme.colors.cardSettingsTextColor)};
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;

  .icon {
    fill: ${(props) => (!props.withSettings ? props.theme.colors.disabledMeatballItem : props.theme.cardAnnotationsMenu.iconColor)};
    :not(:first-child){
      margin-right: 13px;
    }
    :first-child{
      width: 100%;
      height: 100%;
    }
  }
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  align-self: center;
  margin-right: 12px;
  margin-bottom: 2px;
`;
